"use client";

import { useAuthStore } from "@/store/authStore";
import { usePathname, useRouter } from "next/navigation";
import { useEffect, useState } from "react";

interface AuthGuardProps {
   children: React.ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
   const pathname = usePathname();
   const router = useRouter();
   const [isChecking, setIsChecking] = useState(true);
   const isAuthenticated = useAuthStore(state => state.isAuthenticated);
   const token = useAuthStore(state => state.token);

   useEffect(() => {
      // Skip auth check for login page
      if (pathname === "/login") {
         setIsChecking(false);
         return;
      }

      // Check if user is authenticated
      if (!token || !isAuthenticated) {
         router.replace("/login");
      } else {
         setIsChecking(false);
      }
   }, [pathname, token, isAuthenticated, router]);

   // Show loading during auth check
   if (isChecking && pathname !== "/login") {
      return (
         <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--background))]">
            <div className="w-10 h-10 border-2 border-[hsl(var(--primary))] border-t-transparent rounded-full animate-spin" />
         </div>
      );
   }

   return <>{children}</>;
}
